import React from "react";
import { Helmet } from "react-helmet";

function Contact() {

 return (
 <div>

<Helmet>
        <title>Halwa Stuffed Dates | Premium Calicutt</title>
        <meta name="description" content="Fusion of Authentic Kozhikoden Halwa and Medjool Dates. 60 Days Shelf Life | Net Weight 168 g" />
        <meta name="keywords" content="halwa, stuffed dates, Calicut sweets, medjool, premium halwa" />
      </Helmet>

 </div>
 )

}

export default Contact